import './index.sass'
import "../../main.css"

import StoreContext from "../../store/RootStore";
import { useEffect, useState, useRef, useCallback } from "react";
import { observer } from "mobx-react";
import Preloader from "../../components/preloader";
import Notification from "../../components/notification";
import LoginHandler from "../../functions/login";

function CraftPage() {
  const { AccountStore } = StoreContext();

  const [Crafts, setActiveCrafts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Instance stable de LoginHandler pour satisfaire eslint-plugin-react-hooks
  const loginHandlerRef = useRef(null);
  if (loginHandlerRef.current === null) {
    loginHandlerRef.current = new LoginHandler();
  }
  const loginHandler = loginHandlerRef.current;
  const wax = loginHandler.wax;

  const GetTemplate = useCallback(
    async (x) => {
      const path = `/atomicassets/v1/templates/dovdivisions/${x.template_id}`;
      const response = await fetch(loginHandler.aa + path, {
        headers: { "Content-Type": "text/plain" },
        method: "GET",
      });
      const body = await response.json();
      return {
        template_id: x.template_id,
        type: x.type,
        costs: x.costs,
        schema: x.schema,
        available: x.available,
        img: body.data.immutable_data.img,
        name: body.data.immutable_data.name,
      };
    },
    [loginHandler]
  );

  const sort = useCallback(
    async (dd) => {
      const promisesToAwait = [];
      for (let i = 0; i < dd.length; i++) {
        promisesToAwait.push(GetTemplate(dd[i]));
      }
      return promisesToAwait;
    },
    [GetTemplate]
  );

  const getCraftData = useCallback(async () => {
    setLoading(true);
    const body = await wax.rpc.get_table_rows({
      json: true,
      code: "dovutilstake",
      scope: "dovutilstake",
      table: "cdata",
      limit: 10,
    });
    const data = body.rows;
    const promises = await sort(data);
    const responses = await Promise.all(promises);
    setActiveCrafts(responses);
    setLoading(false);
  }, [wax.rpc, sort]);

  useEffect(() => {
    if (AccountStore.accountAddress) {
      getCraftData();
    }
  }, [AccountStore.accountAddress, getCraftData]);

  async function buy(template_id) {
    await loginHandler.sendTransaction(
      [
        {
          account: "dovutilstake",
          name: "startcraft",
          authorization: [
            {
              actor: AccountStore.accountAddress,
              permission: AccountStore.getUserData().requestPermission,
            },
          ],
          data: {
            player: AccountStore.accountAddress,
            craft_id: template_id,
          },
        },
      ],
      AccountStore.getUserData()[0],
      "Transaction successfull"
    );
    setTimeout(() => {
      getCraftData();
      loginHandler.getUserBalancetkn();
      loginHandler.getUserBalancewax();
    }, 1000);
  }

  function render() {
    const currentAssets = Crafts.slice(0, 6);
    return (
      <>
        {currentAssets.map((asset, index) => (
          <div className="cards_buildings startRedCounter" key={`staked-asset-${index}`}>
            <img src={`https://dov-gw.mypinata.cloud/ipfs/${asset.img}`} alt="" />
            <div className="textRedCounter">
              <h2>{asset.template_id}</h2>
              <h3>Remains</h3>
              <p>{asset.available}</p>
              {asset.available > 0 ? (
                <button className="craftBtn" onClick={() => buy(asset.template_id)}></button>
              ) : (
                <></>
              )}
            </div>
            <div className="cards_button dovxRedZone">
              {asset.costs.map((cost, idx) => (
                <div className="dovxText" key={`cost-${asset.template_id}-${idx}`}>
                  <h3>{cost.split(" ")[1]}</h3>
                  <p className="whiteColor">{cost.split(" ")[0]}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </>
    );
  }

  return (
    <div className="parent">
      <Notification />
      {loading ? (
        <Preloader />
      ) : (
        <div id="buildings">
          <div className="content-wrapper">
            <div className="staking-assets-container">{render()}</div>
          </div>
        </div>
      )}
    </div>
  );
}

export default observer(CraftPage);
